/**
 * Enum representing different routes in the application.
 * @readonly
 * @enum {string}
 */
enum Routes {
  /**
   * The home route.
   * @type {string}
   */
  HOME = "/",

  /**
   * The dashboard route.
   * @type {string}
   */
  DASHBOARD = "/dashboard",

  /**
   * The login route.
   * @type {string}
   */
  LOGIN = "/login",

  /**
   * The Plan route.
   * @type {string}
   */
  PLAN_LIST = "/plan/list",
  PLAN_ADD = "/plan/add",

  /**
   * The Translation route.
   * @type {string}
   */
  TRANSLATION_ADD = "/translation/add",
  TRANSLATION_LIST = "/translation/list",

  /**
   * The Product route.
   * @type {string}
   */
  PRODUCT_ADD = "/product/add",
  PRODUCT_LIST = "/product/list",

  /**
   * The User route.
   * @type {string}
   */
  USER_ADD = "/user/add",
  USER_LIST = "/user/list",

  /**
   * The Email Template route.
   * @type {string}
   */
  EMAIL_TEMPLATE_ADD = "/email-template/add",
  EMAIL_TEMPLATE_LIST = "/email-template/list",

  /**
   * The Product Type route.
   * @type {string}
   */
  PRODUCT_TYPES_ADD = "/product-type/add",
  PRODUCT_TYPES_LIST = "/product-type/list",

  /**
   * The Licence Version route.
   * @type {string}
   */
  VERSION_LICENCE_ADD = "/licence-version/add",
  VERSION_LICENCE_LIST = "/licence-version/list",

  /**
   * The Checkout route.
   * @type {string}
   */
  ORDER_COMPLETE = "/checkout",

  /**
   * The Redbird route.
   * @type {string}
   */
  REDBIRD_ADD = "/redbird/add",
  REDBIRD_LIST = "/redbird/list",

  /**
   * The Module route.
   * @type {string}
   */
  MODULE_ADD = "/module/add",
  MODULE_LIST = "/module/list",

  /**
   * The Payout route.
   * @type {string}
   */
  PAYOUT_LIST = "/payout/list",
}

export default Routes;
